<script setup lang="ts">
import { mdiPlus } from '@mdi/js';
import Button from '@/components/buttons/Button.vue';
import Tooltip from '@/components/Tooltip/Tooltip.vue';
import type { RouteLocationRaw } from 'vue-router';

interface PtwAddButtonProps {
  to?: RouteLocationRaw;
}

defineProps<PtwAddButtonProps>();
</script>

<template>
  <Tooltip>
    <template #tooltip>
      {{ $t('Add') }}
    </template>
    <template #target="{ props }">
      <Button
        v-bind="props"
        variant="text"
        size="large"
        :icon="mdiPlus"
        :to="to"
        aria-label="Add"
      />
    </template>
  </Tooltip>
</template>
